import { lazy } from 'react';
import ProtectedRoute from '../ProtectRoute';
import AuthCheckAeps from 'views/AuthCheckAeps';
import Loadable from 'ui-component/Loadable';
const AadhaarPay1 = Loadable(lazy(() => import('views/bankingServices/AEPS(AEPS)/AadhaarPay')));
const BalanceEnquiry1 = Loadable(lazy(() => import('views/bankingServices/AEPS(AEPS)/BalanceEnquiry')));
const CashWithdrawal1 = Loadable(lazy(() => import('views/bankingServices/AEPS(AEPS)/CashWithdrawal')));
const MiniStatementAadhaar1 = Loadable(lazy(() => import('views/bankingServices/AEPS(AEPS)/MiniStatementAadhaar')));
const MiniStatementReciept1 = Loadable(lazy(() => import('views/bankingServices/AEPS(AEPS)/Reciept/MiniStatementReciept')));
const BalanceEnquiryReciept1 = Loadable(lazy(() => import('views/bankingServices/AEPS(AEPS)/Reciept/BalanceEnquiryReciept')));
const Merchantmodel = Loadable(lazy(() => import('views/iciciRegistration/MerchantModel')));
const Address = Loadable(lazy(() => import('views/iciciRegistration/Address')));
const KYC = Loadable(lazy(() => import('views/iciciRegistration/kyc')));
const AepsReport1 = Loadable(lazy(() => import('views/bankingServices/AEPS(AEPS)/AepsReport')));
const AadhaarpayReport1 = Loadable(lazy(() => import('views/bankingServices/AEPS(AEPS)/AadhaarPayReport')));
const Aeps_Authentication1 = Loadable(lazy(() => import('views/bankingServices/AEPS(AEPS)/Aeps_Authentication')));
const Kycauthentication1 = Loadable(lazy(() => import('views/bankingServices/AEPS(AEPS)/aepsKycAuthentication')));
const AepsRecieptPage1 = Loadable(lazy(() => import('views/bankingServices/AEPS(AEPS)/AepsRecieptPage')));
const AepsSdkCashwithdrawal1 = Loadable(lazy(() => import('views/bankingServices/AEPS(AEPS)/AepsSdk/AepsSdkCashwithdrewal')));
const AepsSdkMinistatement1 = Loadable(lazy(() => import('views/bankingServices/AEPS(AEPS)/AepsSdk/AepsSdkMiniStatement')));
const AepsSdkBalanceEnquiry1 = Loadable(lazy(() => import('views/bankingServices/AEPS(AEPS)/AepsSdk/AepsSdkBalanceEnquiry')));
const Aeps1 = Loadable(lazy(() => import('views/bankingServices/AEPS(AEPS)/Aeps1/Aeps1')));
import AepsSdkCashDeposit1 from 'views/bankingServices/AEPS(AEPS)/AepsSdk/AepsSdkCashDeposit';

export const aepsRoutes = {
    path: '',
    children: [
        {
            path: 'aadhaarpay',
            element: <AuthCheckAeps element={<AadhaarPay1 />} />
        },
        {
            path: 'aeps/balanceEnquiry',
            element: <ProtectedRoute element={<BalanceEnquiry1 />} />
        },
        {
            path: 'aeps/cashWithdrawal',
            element: <ProtectedRoute element={<CashWithdrawal1 />} />
        },
        {
            path: 'aeps/miniStatementAadhaar',
            element: <ProtectedRoute element={<MiniStatementAadhaar1 />} />
        },
        {
            path: 'aeps/miniStatement',
            element: <ProtectedRoute element={<MiniStatementReciept1 />} />
        },
        {
            path: 'aeps/BalanceEnquiryReciept',
            element: <ProtectedRoute element={<BalanceEnquiryReciept1 />} />
        },
        {
            path: 'aeps/iciciregistration',
            element: <ProtectedRoute element={<Merchantmodel />} />
        },
        {
            path: 'aeps/Address',
            element: <ProtectedRoute element={<Address />} />
        },
        {
            path: 'aeps/kyc',
            element: <ProtectedRoute element={<KYC />} />
        },
        {
            path: 'aeps/aepsreport',
            element: <ProtectedRoute element={<AepsReport1 />} />
        },
        {
            path: 'aeps/aadhaarpayreport',
            element: <ProtectedRoute element={<AadhaarpayReport1 />} />
        },
        {
            path: 'aepsauthentication',
            element: <ProtectedRoute element={<Aeps_Authentication1 />} />
        },
        {
            path: 'aeps/kycauthentication',
            element: <ProtectedRoute element={<Kycauthentication1 />} />
        },
        {
            path: 'aeps/aepsreceipt',
            element: <ProtectedRoute element={<AepsRecieptPage1 />} />
        },
        {
            path: 'aeps/aeps-sdk-cw',
            element: <ProtectedRoute element={<AepsSdkCashwithdrawal1 />} />
        },
        {
            path: 'aeps/aeps-sdk-ministatement',
            element: <ProtectedRoute element={<AepsSdkMinistatement1 />} />
        },
        {
            path: 'aeps/aeps-sdk-balanceenquiry',
            element: <ProtectedRoute element={<AepsSdkBalanceEnquiry1 />} />
        },
        {
            path: 'aeps/aeps-sdk-cashdeposit',
            element: <ProtectedRoute element={<AepsSdkCashDeposit1 />} />
        },
        {
            path: 'aeps',
            element: <AuthCheckAeps element={<Aeps1 />} />
        }
    ]
};
